module.exports = __webpack_public_path__ + "static/img/rlzy.969bc63c.png";